<template>
  <v-container>
    <v-layout row wrap>
      <!-- About purchased plans & screenings -->
      <v-flex xs12 >
        <v-toolbar color="primary background--text"  tabs>
          <v-toolbar-title>
            <span>{{$t('hello.title')}} {{ profile.name ? profile.name : profile.email }}</span>
          </v-toolbar-title>
          <div v-if="isLoggedInWithLink || isPreviewUser">
            <v-tooltip slot="append" top color="primary">
              <v-chip
                slot="activator"
                color="yellow"
                class="black--text"
                small
              >
                <v-icon small>mdi-drama-masks</v-icon>
                <strong>{{ $t("screener.anonymous_mode.title") }}</strong>
              </v-chip>
              <span class="background--text body-1" v-html="$t('screener.anonymous_mode.tooltip')"></span>
            </v-tooltip>
          </div>
          <v-spacer></v-spacer>

          <v-toolbar-items></v-toolbar-items>

          <v-toolbar-items class="hidden-sm-and-down">
            <v-btn
              flat
              class="px-0 background--text"
              @click.stop="$router.push({ name: 'screeners.upcoming' })"
              >{{ $t("screener.browse_screenings.title") }}</v-btn
            >
          </v-toolbar-items>

          <v-menu class="hidden-md-and-up">
            <v-toolbar-side-icon slot="activator" class="background--text"></v-toolbar-side-icon>
            <v-list>
              <v-list-tile
                @click.stop="$router.push({ name: 'screeners.upcoming' })"
              >
            <AddDeviceDialog @verifyShortCode="verifyShortCode"></AddDeviceDialog>
            <v-menu class="hidden-md-and-up">
              <v-toolbar-side-icon slot="activator" class="primary--text"></v-toolbar-side-icon>
              <v-list>
                <v-list-tile
                  @click.stop="$router.push({ name: 'screeners.upcoming' })"
                >
                  <v-list-tile-content>
                    <v-list-tile-title >{{
                      $t("screener.browse_screenings.title")
                    }}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-menu>
                <v-list-tile-content>
                  <v-list-tile-title>{{
                    $t("screener.browse_screenings.title")
                  }}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>

          <template v-slot:extension>
            <v-tabs v-model="tab" color="primary"  show-arrows >
              <v-tabs-slider color="background"></v-tabs-slider>
              <v-tab
                class="background--text"
                href="#screenings"
              >{{ $t("screenings.title") }}</v-tab>
              <v-tab
                class="background--text"
                href="#vod-movies">{{
                $t("screener.btn.vod_movies")
              }}</v-tab>
              <v-tab
                class="background--text"
                href="#groupPurchases">{{
                $t("screener.purchased_passes.title")
              }}</v-tab>
              <v-tab
                href="#bookings"  class="background--text">{{$t("screener.ticket_bookings.title")}}</v-tab>
              <v-tab
                href="#tvApp" class="background--text">{{$t('tvapp.title')}}</v-tab>
              <v-tab
                v-if="user_subscription"
                href="#subscription" class="background--text">{{$t('subscription.title')}}</v-tab>
              <v-tab
                v-if="!isLoggedInWithLink && !isPreviewUser" href="#consumerProfile"  class="background--text">{{
                $t("screener.profile.title")
              }}</v-tab>
            </v-tabs>
          </template>
        </v-toolbar>

        <v-tabs-items v-model="tab">
          <v-tab-item value="screenings">
            <Screenings v-if="tab == DashboardTabs.events" :eventType="DEFINES.EVENT_TYPE.STANDARD_EVENTS" />
          </v-tab-item>
          <v-tab-item value="vod-movies">
            <Screenings v-if="tab == DashboardTabs.vodEvents" :eventType="DEFINES.EVENT_TYPE.VOD_EVENTS" />
          </v-tab-item>
          <v-tab-item value="groupPurchases">
            <PurchasedPlans v-if="tab == DashboardTabs.purchases" />
          </v-tab-item>
          <v-tab-item value="bookings">
            <PhysicalEventTicketBookings v-if="tab == DashboardTabs.tickets" />
          </v-tab-item>
          <v-tab-item value="tvApp">
            <v-card class="pa-4">
              <AddDeviceDialog @verifyShortCode="verifyShortCode"></AddDeviceDialog>
            </v-card>
          </v-tab-item>
          <v-tab-item 
            v-if="user_subscription"
            value="subscription"
          >
            <Subscription v-if="tab == DashboardTabs.subscription" />
          </v-tab-item>
          <v-tab-item v-if="!isLoggedInWithLink && !isPreviewUser" value="consumerProfile">
            <ConsumerProfile />
          </v-tab-item>
        </v-tabs-items>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Screenings from "@/components/consumer/Screening";
import PurchasedPlans from "@/components/consumer/PurchasedPlans";
import PhysicalEventTicketBookings from "@/components/consumer/TicketBookings";
import AddDeviceDialog from "@/components/consumer/AddDeviceDialog";
import i18n from "@/i18n"
import ConsumerProfile from "@/components/consumer/Profile";
import Subscription from "@/components/consumer/Subscription";
import { mapGetters, mapState } from "vuex";

const DashboardTabs = {
  events:"screenings",
  purchases:"groupPurchases",
  tickets:"bookings",
  profile:"consumerProfile",
  vodEvents:"vod-movies",
  subscription:"subscription"
}

export default {
  async beforeRouteEnter(to, from, next) {
    await next((vm) => {
     if(vm.$route.query && vm.$route.query.tab){
        vm.switchTab(vm.$route.query.tab);
      }
    });
  },
  name: "ConsumerDashboard",
  data() {
    return {
      tab: null,
      DashboardTabs
    };
  },
  components: {
    Screenings,
    PurchasedPlans,
    ConsumerProfile,
    AddDeviceDialog,
    PhysicalEventTicketBookings,
    Subscription
  },
  computed: {
    ...mapState({
      profile: state => state.consumer.profile,
      user_subscription: state => state.subscription.subscription,
    }),
    ...mapGetters("auth", {
      isLoggedInWithLink: "isLoggedInWithLink",
      isPreviewUser:"isPreviewMode"
    }),
    ...mapState({
      currentCompany: (state) => state.company.company,
    }),
  },
  watch:{
    '$route' (to, from){
      if(this.$route.query && this.$route.query.tab){
        this.switchTab(this.$route.query.tab);
      }
    }
  } ,
  methods: {
    async verifyShortCode(event){
      this.$store.dispatch('consumer/verifyShortCode',{
        short_code: event.short_code
      })
      .then(response => {
        this.$store.dispatch("app/showMessage", {
          message: i18n.t('my_account.add_device.added.successfully'),
          color: 'success'
        });
      })
      .catch(error => {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error"
        });
      })
    },
    switchTab(tab){
      if(DashboardTabs.hasOwnProperty(tab)){
          this.tab = DashboardTabs[tab];
          return;
      }
      this.tab = DashboardTabs.events;
    }
  }
};
</script>

<style></style>
